import * as actionTypes from "../actions/actionTypes";

const login = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.CURRENT_LANGUAGE:
      return { ...state, Lang: action.payload ?? "ar" };
    case actionTypes.USER_INFO:
      return { ...state, userToken: action.payload };
    case actionTypes.USER_DATA:
      return { ...state, userData: action.payload };
    case actionTypes.AUTHENTICATED:
      return { ...state, isAuthenticated: action.payload };
    case actionTypes.ROOM:
      return { ...state, room: action.payload };
    case actionTypes.LOGOUT:
      return {
        ...state,
        userToken: action.payload,
        userData: action.payload,
        isAuthenticated: action.payload,
      };
    default:
      return state;
  }
};

export default login;
